export const ROOT = "/admin/instant-lucky-draw"
export const INSTANT_LUCKY_DRAW_PARTICIPANT = `${ROOT}/view/:instantLuckyDrawID/`;